/**
 * Helper functions for image URL that must NOT access global objects
 */
const imageUrlHelpers = function () {

  const getParamsStandard = ( view, garmentIndex, designindex, artworkcolorindex, backOption, type1ThreadColor, type1FontIndex, type2ThreadColor, type2FontIndex, designEnabled, frontText1, frontText2, backText1, backText2, type1Text, type2Text, scale) => {

    if ( type1Text === 'LEAVE_IT_BLANK' ) {
      type1ThreadColor = '';
      type1FontIndex = '';
    }

    if ( type2Text === 'LEAVE_IT_BLANK' ) {
      type2ThreadColor = '';
      type2FontIndex = '';
    }

    return {
      view,
      garmentIndex,
      designindex,
      artworkcolorindex,
      backOption,
      frontText1,
      frontText2,
      backText1,
      backText2,
      type1Text,
      type1ThreadColor,
      type1FontIndex,
      type2Text,
      type2ThreadColor,
      type2FontIndex,
      designEnabled,
      scale
    };
  };

  const getParamsPrintAndEmbroidery = (viewOption, vendorRef, designIndex, artworkcolorindex, type1ThreadColor, type1FontIndex, type2ThreadColor, type2FontIndex, designEnabled, frontText1, frontText2, backText1, backText2, scale) => {

    let designOption;


    if ( frontText1 === '' ) {
      type1ThreadColor = '';
      type1FontIndex = '';
    }

    if ( frontText2 === '' ) {
      type2ThreadColor = '';
      type2FontIndex = '';
    }

    if ( (designEnabled === '0' || designEnabled === '') ) {
      designIndex = '';
      designOption = '';
      artworkcolorindex = '';
    }

    return {
      viewOption,
      vendorRef,
      designIndex,
      designOption,
      artworkcolorindex,
      frontText1,
      frontText2,
      backText1,
      backText2,
      type1Text: frontText1,
      type1ThreadColor,
      type1FontIndex,
      type2Text: frontText2,
      type2ThreadColor,
      type2FontIndex,
      type3Text: backText1,
      type4Text: backText2,
      designEnabled,
      scale
    };
  };

  return {
    getParamsStandard,
    getParamsPrintAndEmbroidery
  };
};

module.exports = imageUrlHelpers;
